import { purple } from "./purple";
import { songdrive_dark } from "./songdrive_dark";
import { dracula } from "./dracula";
import { forest } from "./forest";
import { halloween } from "./halloween";
import { pink } from "./pink";
import { red } from "./red";
import { synthwave } from "./synthwave";
import { yellow } from "./yellow";

export const themes = {
	dracula,
	forest,
	pink,
	yellow,
	red,
	purple,
	songdrive_dark,
	halloween,
	synthwave,
};

export const sortedThemeNames = Object.keys(themes).sort((a, b) => {
    if (a.includes('songdrive') && !b.includes('songdrive')) {
        return -1;
    }
    if (!a.includes('songdrive') && b.includes('songdrive')) {
        return 1;
    }
    return a.localeCompare(b);
});
